// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__27hag","column":"style_column__c1eO5","row":"style_row__PinuB"};